import {Headline} from 'components/atoms/Text/Headline';
import {Icon} from 'components/atoms/Media/Icon';

import {P} from 'components/atoms/Text/P';
import {ReadMore} from 'components/atoms/LinksAndButtons/ReadMore';
import {SiteSpecificContent} from 'components/atoms/SiteSpecificContent';

import 'components/molecules/ResidentialCards/ResidenceCardsOld/style.scss';
import * as React from 'react';
import {FormattedMessage} from 'react-intl';
import {DisposalForm} from 'features/search/filters/enums';
import {ReadMoreAlign, ParagraphSize, HeadlineLevel, HeadlineSize} from 'features/ui/enums';
import {renderInhabitDate} from 'features/services/utils/date-helpers';
import {getLocalizedPrice, getLocalizedRok} from 'features/services/utils/env-helper';
import {capitalizeFirstLetter} from 'features/services/utils/helpers';
import {getFormattedMessage} from 'features/services/utils/language-helper';
import {cleanFinnishNames, getDisposalFormName, getMunicipalityName} from 'features/services/utils/name-helpers';

import './style.scss';
import {getResidenceTypeIcon} from 'components/icons/icon-helper';
import {SearchResult} from "features/search/types";

interface Props {
    stage: SearchResult;
    hideArrow?: boolean;
    isOpenToPurchase?: boolean;
}

export const StageSuggestion: React.FunctionComponent<Props> = ({stage, hideArrow: _hideArrow, isOpenToPurchase}) => {
    const shouldRenderPrice = () => {
        if(!stage.minPrice || !stage.maxPrice) return false;

        return stage.minPrice !== null && stage.maxPrice !== null && stage.minPrice !== 0 && stage.maxPrice !== 0;
    };
    const shouldRenderRooms = () => {
        if(typeof stage.minRooms === 'undefined' || stage.minRooms === null) return false;
        if(typeof stage.maxRooms === 'undefined' || stage.maxRooms === null) return false;
        if(stage.minRooms === 0) return false;
        if(stage.maxRooms === 0) return false;

        return true;
    };

    return (
        <div className="stage-suggestion">
            {stage.swanLabel &&
                <div className="stage-suggestion__swan-container">
                    <Icon name="swan-eco-label" sizeS />
                </div>
            }

            {(process.env.NODE_ENV === 'development' && new Date().getMonth() === 5 && (new Date().getDate() > 14 && new Date().getDate() < 26)) ?
                <P size={ParagraphSize.S} className="notranslate">Midsommarkransen</P> ://Easter egg
                <P size={ParagraphSize.S} className="notranslate">{getMunicipalityName(stage)} / {capitalizeFirstLetter(stage.area.name)}</P>
            }

            <Headline 
                level={HeadlineLevel.H2} 
                size={HeadlineSize.M}
                className="notranslate" 
            >
                {capitalizeFirstLetter(cleanFinnishNames(stage.name))}
            </Headline>
            <P>
                {stage.disposalForm &&
                    <SiteSpecificContent notFinland>
                        {getDisposalFormName(stage.disposalForm as DisposalForm)}
                    </SiteSpecificContent>
                }
                {/*divider*/
                    (stage.disposalForm && shouldRenderRooms())
                    && <SiteSpecificContent notFinland>, </SiteSpecificContent>
                }
                {shouldRenderRooms() &&
                    <React.Fragment>
                        {stage.minRooms === stage.maxRooms && getLocalizedRok(stage.minRooms)}
                        {stage.minRooms !== stage.maxRooms && `${stage.minRooms} - ${getLocalizedRok(stage.maxRooms)}` }
                    </React.Fragment>
                }
                {/*divider*/
                    ((stage.disposalForm || shouldRenderRooms())
                    && shouldRenderPrice())
                    && <br />
                }
                {shouldRenderPrice() &&
                    <React.Fragment>
                        <SiteSpecificContent showOnFinland>Velaton hinta</SiteSpecificContent>

                        <SiteSpecificContent showOnFinland>
                            {stage.jmoyTotalPriceMin === stage.jmoyTotalPriceMax && ` ${getLocalizedPrice(stage.jmoyTotalPriceMin)}`}
                            {stage.jmoyTotalPriceMin !== stage.jmoyTotalPriceMax && ` ${getLocalizedPrice(stage.jmoyTotalPriceMin)} - ${getLocalizedPrice(stage.jmoyTotalPriceMax)}`}
                        </SiteSpecificContent>

                        <SiteSpecificContent notFinland>
                            {stage.minPrice === stage.maxPrice && ` ${getLocalizedPrice(stage.minPrice)}`}
                            {stage.minPrice !== stage.maxPrice && ` ${getLocalizedPrice(stage.minPrice)} - ${getLocalizedPrice(stage.maxPrice)}`}
                        </SiteSpecificContent>
                    </React.Fragment>
                }
                {/*divider*/
                    (
                        ((stage.disposalForm || shouldRenderRooms())
                        || shouldRenderPrice())
                    && stage.inhabitDate)
                    && <br />
                }
                {stage.inhabitDate &&
                    <React.Fragment>
                        <FormattedMessage id="jm.components.StageSuggestion.inhabitDate" /> {renderInhabitDate(stage.inhabitDate, stage.inhabitDateEnd, stage.inhabitDateDetermined)}
                    </React.Fragment>
                }
            </P>

            <span className="residence-block__icon">
                {stage.swanLabel &&
                    <div className="stage-suggestion__swan-container">
                        <Icon name="swan-eco-label" sizeS />
                    </div>
                }
                {getResidenceTypeIcon(stage.residenceType)}
            </span>

            {isOpenToPurchase &&
                <ReadMore
                    className="stage-suggestion__purchase-link"
                    align={ReadMoreAlign.RIGHT}
                    text={getFormattedMessage('jm.components.StageCard.purchaseObjects')}
                />
            }
        </div>
    )
};
